import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { useState, useEffect, createContext, useContext } from "react";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";

// Pages
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import BautizosPage from "@/pages/BautizosPage";
import BautizoFormPage from "@/pages/BautizoFormPage";
import BautizoDetailPage from "@/pages/BautizoDetailPage";
import MatrimoniosPage from "@/pages/MatrimoniosPage";
import MatrimonioFormPage from "@/pages/MatrimonioFormPage";
import MatrimonioDetailPage from "@/pages/MatrimonioDetailPage";
import ConfirmacionesPage from "@/pages/ConfirmacionesPage";
import ConfirmacionFormPage from "@/pages/ConfirmacionFormPage";
import ConfirmacionDetailPage from "@/pages/ConfirmacionDetailPage";
import PersonasPage from "@/pages/PersonasPage";
import PersonaFormPage from "@/pages/PersonaFormPage";
import MinisteriosPage from "@/pages/MinisteriosPage";
import MinisterioMiembrosPage from "@/pages/MinisterioMiembrosPage";
import IntencionesPage from "@/pages/IntencionesPage";
import InfoGeneralPage from "@/pages/InfoGeneralPage";
import DocumentacionPage from "@/pages/DocumentacionPage";
import EntidadesPage from "@/pages/EntidadesPage";
import PerfilPage from "@/pages/PerfilPage";
import UsuariosPage from "@/pages/UsuariosPage";
import ArbolGenealogico from "@/pages/ArbolGenealogico";

// Layout
import Layout from "@/components/Layout";

// Auth Context
export const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();
  
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-stone-50">
        <div className="animate-pulse text-stone-400">Cargando...</div>
      </div>
    );
  }
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedUser = localStorage.getItem("ecclesia_user");
    const storedToken = localStorage.getItem("ecclesia_token");
    
    if (storedUser && storedToken) {
      try {
        const parsedUser = JSON.parse(storedUser);
        setUser(parsedUser);
      } catch (e) {
        localStorage.removeItem("ecclesia_user");
        localStorage.removeItem("ecclesia_token");
      }
    }
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    setUser(userData);
    localStorage.setItem("ecclesia_user", JSON.stringify(userData));
    localStorage.setItem("ecclesia_token", token);
  };

  const logout = () => {
    setUser(null);
    localStorage.removeItem("ecclesia_user");
    localStorage.removeItem("ecclesia_token");
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route
            path="/*"
            element={
              <ProtectedRoute>
                <Layout>
                  <Routes>
                    <Route path="/" element={<DashboardPage />} />
                    <Route path="/bautizos" element={<BautizosPage />} />
                    <Route path="/bautizos/nuevo" element={<BautizoFormPage />} />
                    <Route path="/bautizos/:id" element={<BautizoDetailPage />} />
                    <Route path="/bautizos/:id/editar" element={<BautizoFormPage />} />
                    <Route path="/matrimonios" element={<MatrimoniosPage />} />
                    <Route path="/matrimonios/nuevo" element={<MatrimonioFormPage />} />
                    <Route path="/matrimonios/:id" element={<MatrimonioDetailPage />} />
                    <Route path="/matrimonios/:id/editar" element={<MatrimonioFormPage />} />
                    <Route path="/confirmaciones" element={<ConfirmacionesPage />} />
                    <Route path="/confirmaciones/nuevo" element={<ConfirmacionFormPage />} />
                    <Route path="/confirmaciones/:id" element={<ConfirmacionDetailPage />} />
                    <Route path="/confirmaciones/:id/editar" element={<ConfirmacionFormPage />} />
                    <Route path="/personas" element={<PersonasPage />} />
                    <Route path="/personas/nuevo" element={<PersonaFormPage />} />
                    <Route path="/personas/:id/editar" element={<PersonaFormPage />} />
                    <Route path="/arbol-genealogico" element={<ArbolGenealogico />} />
                    <Route path="/arbol-genealogico/:id" element={<ArbolGenealogico />} />
                    <Route path="/ministerios" element={<MinisteriosPage />} />
                    <Route path="/ministerios/:id/miembros" element={<MinisterioMiembrosPage />} />
                    <Route path="/intenciones" element={<IntencionesPage />} />
                    <Route path="/info" element={<InfoGeneralPage />} />
                    <Route path="/documentacion" element={<DocumentacionPage />} />
                    <Route path="/entidades" element={<EntidadesPage />} />
                    <Route path="/perfil" element={<PerfilPage />} />
                    <Route path="/usuarios" element={<UsuariosPage />} />
                  </Routes>
                </Layout>
              </ProtectedRoute>
            }
          />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </AuthContext.Provider>
  );
}

export default App;
